import { useState, useEffect, Fragment } from "react";
import {
  CardNumberElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

import { Toaster } from "react-hot-toast";
import Loader from "../Loader/loader";
import TrackingScripts from "./trackingComponent";
import { handleSubmit } from "./eventHandler";
import PersonalDetailsSection from "../checkout/PersonalDetailsSection";
import PaymentDetailsSection from "../checkout/PaymentDetailsSection";
import DisclaimerSection from "../checkout/DisclaimerSection";
import { useCheckoutForm } from "../checkout/useCheckoutForm";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import SDK from "../../config";
const CheckoutForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const stripe = useStripe();
  const elements = useElements();
 
  const params = new URLSearchParams(location.search);
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get("referralCode");
  useEffect(() => {
    if (referralCode) {
      SDK.setReferralCode(referralCode);
    }
  }, [referralCode]);

  
  const {
    email,
    cardName,
    showCardDetails,
    pageLoader,
    paymentRequest,
    canMakePayment,
    regionText,
    selectedPlan,
    setCardName,
    setShowCardDetails,
    setPageLoader,
    handleEmailChange,
    getCurrencySymbol,
    
  } = useCheckoutForm(stripe);

  const onSubmit = (event) => {
    handleSubmit(
      event,
      stripe,
      elements,
      email,
      CardNumberElement,
      cardName,
      setPageLoader,
      navigate,
      referralCode
    );
  };

  return (
    <Fragment>
      <TrackingScripts />
      <Loader pageLoader={pageLoader} style={{ width: "100vw" }} />
      <Toaster />

      <div>
        <div>
          <form onSubmit={onSubmit}>
            <div className="bg-primary200 rounded-sm p-6 my-8">
              <PersonalDetailsSection
                email={email}
                onEmailChange={handleEmailChange}
              />

              <PaymentDetailsSection
                selectedPlan={selectedPlan}
                referralCode={referralCode}
                canMakePayment={canMakePayment}
                paymentRequest={paymentRequest}
                showCardDetails={showCardDetails}
                onShowCardDetails={() => setShowCardDetails(true)}
                cardName={cardName}
                onCardNameChange={(e) => setCardName(e.target.value)}
                getCurrencySymbol={getCurrencySymbol}
                stripeEnabled={!!stripe}
              />
            </div>
          </form>
        </div>

        <DisclaimerSection regionText={regionText} />
      </div>
    </Fragment>
  );
};

export default CheckoutForm;
